<template lang="html">
<section class="contenedor-input type-text full-slot mb-0">
      <template >
        <div class="contenedor-input mb-0 " v-if="tutoresSelect.length != 0 ">
          <div class="contenedor-validador row-start" v-if="$route.name == 'propuesta-practicas' && alumno == true">
             <div class="contenedor-input one-slot mb-0">
              <label for="">Email del firmante*</label>
              <input type="text" v-model="emailFirmante" name="emailFirmante" v-validate="'required|email'">
              <!-- <span class='error'>{{ errors.first('emailFirmante') }}</span> -->
            </div>
            <button class="btn -solid-primary mb-0" v-if="!!emailFirmante && !tutorObject.nombre"  @click="validarTutor()" :loading="loadingCheched">Validar
              contacto</button>
           <div class="w-100 mt-20" v-if="openEditData || okContacto || createContacto">
              <p>
               <strong v-if="openEditData">Lo sentimos, el contacto no se encuentra en la empresa. Por favor rellene los siguiente datos para poder darlo de alta:</strong>
              <strong v-if="okContacto" style="color: green">Su contacto ha sido validado correctamente.</strong>
              <strong v-if="createContacto" style="color: green">Su contacto ha sido creado correctamente.</strong>
             </p>
            </div>
          </div>
          <template v-else>
          <label for="">Firmante del convenio*</label>
          <p class="mb-0" @click="newTutor">Seleccione a continuación la persona con poderes para la firma, si no está entre las opciones disponibles, pinche <u class="cursor-pointer">aquí</u> para indicar sus datos.​</p>
          <select name="tutores" v-model="tutorObject" v-validate="'required'" @change="changeTutor">
            <option :value=null disabled>-Seleccionar-</option>
            <option :value="tutor" v-for="tutor in tutoresSelectOrdenados" :key="tutor.id">{{tutor.nameComplet}}  </option>
          </select>
          </template>
        </div>
    

        <div v-if="!!!nocompletTutor || openEditData == true" class="box-gray-content">
          <form v-if="saveBtnTutor && loadingTutor  == false ">
            <div class="contenedor-input type-text one-slot">
                <label for="">{{ $t('registro.tratamiento') }}</label>
                <select name="tratamiento" v-model="tutorObject.tratamiento">
                <option value="" selected disabled>{{ "-Elige una-" }}</option>
                <option value="D.">{{ "D." }}</option>
                <option value="Da.">{{ "Da." }}</option>
                </select>
                <span class='error'>{{ errors.first('tratamiento') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
              <label for="nombre">{{ $t('formulario_incorporacion.tutor_nombre') }}*</label>
              <input type="text" name="nombre" v-model="tutorObject.nombre" v-validate="'required|min:3'" @change="saveBtnTutor = true">
              <span class='error'>{{ errors.first('nombre') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
              <label for="">{{ $t('formulario_incorporacion.tutor_apellidos') }}*</label>
              <input type="text" name="apellidos" v-model="tutorObject.apellidos" v-validate="'required|min:3'" @change="saveBtnTutor = true">
              <span class='error'>{{ errors.first('apellidos') }}</span>
            </div>
            <div class="contenedor-input one-slot -wo-margin">
              <label for="email">{{$t('registro.email')}}*</label>
              <input type="text" name="email" v-model="tutorObject.email" v-validate="'required|email'" @change="saveBtnTutor = true">
              <span class='error'>{{ errors.first('email')}}</span>
            </div>
            <div class="contenedor-input type-text one-slot">
              <label for="dni">NIF</label>
              <input type="text" name="dni" v-model="tutorObject.nif" v-validate="'min:9'">
              <span class='error'>{{ errors.first('dni') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
              <label for="telefono">{{ $t('formulario_incorporacion.tutor_telefono') }}*</label>
              <input type="text" name="telefono" v-model="tutorObject.telefono1" v-validate="'required|max:14|min:9|integer'" @change="saveBtnTutor = true">
              <span class='error'>{{ errors.first('telefono') }}</span>
            </div>
             <div class="contenedor-input type-text one-slot -wo-margin">
              <label for="telefono2">{{ $t('formulario_incorporacion.tutor_telefono') }} 2</label>
              <input type="text" name="telefono2" v-model="tutorObject.telefono2" v-validate="'max:14|min:9|integer'" @change="saveBtnTutor = true">
              <span class='error'>{{ errors.first('telefono2') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
              <label for="">{{ $t('formulario_incorporacion.tutor_cargo') }}</label>
              <input type="text" name="cargo" v-model="tutorObject.puesto" v-validate="'min:3'" @change="saveBtnTutor = true">
              <span class='error'>{{ errors.first('cargo') }}</span>
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
              <label for="">{{ $t('formulario_incorporacion.departamento') }}</label>
              <input type="text" name="departamento" v-model="tutorObject.departamento" @change="saveBtnTutor = true">
              <span class='error'>{{ errors.first('departamento') }}</span>
            </div>
            <div class="contenedor-input type-text three-slot -wo-margin">
              <label for="">Dirección</label>
              <input type="text" name="direccion" v-model="tutorObject.direccion" v-validate="'min:3'" @change="saveBtnTutor = true">
            </div>
            <div class="contenedor-input type-text one-slot">
              <label for="">{{$t('oferta.pais')}}</label>
              <select name="pais" v-model="tutorObject.idPais" v-if="$t('paisesList')" @change="saveBtnTutor = true" >
                <option value="">-Seleccionar-</option>
                <option  v-for="(el, key) in  Object.entries($t('paisesList')).sort(([, valorA], [, valorB]) => valorA.localeCompare(valorB)) " :value="el[0]">{{el[1]}}</option>
              </select>
            </div>
            <div class="contenedor-input type-text one-slot">
              <label for="">{{$t('oferta.provincia')}}</label>
              <input type="text" name="provincia" v-model="tutorObject.provincia" v-if="tutorObject.idPais != 1" v-validate="'min:3'" @change="saveBtnTutor = true">
              <select name="provincia" v-model="tutorObject.provincia" v-else @change="saveBtnTutor = true">
                <option value="">-Selecciona una provincia-</option>
                <option v-if="!!provinciasComplet" v-for="(el, key) in provinciasComplet" :value="el.idProvincia">{{ el.nameProvincia }}</option>
              </select>
            </div>
            <div class="contenedor-input one-slot">
              <label for="">Localidad</label>
              <select name="localidad" v-model="tutorObject.idLocalidad" v-if="tutorObject.idPais == 1 && provinciasComplet[tutorObject.provincia]" @change="saveBtnTutor = true">
                <option value="">{{$t('registro.selecciona_localidad')}}</option>
                 <option v-if="!!provinciasComplet[tutorObject.provincia]['localidades']" v-for="(el, key) in provinciasComplet[tutorObject.provincia]['localidades'] " :value="key">{{ el }}  </option>
              </select>
              <input type="text" name="localidad" v-model="tutorObject.localidad" v-else @change="saveBtnTutor = true">
            </div>
            <div class="contenedor-input type-text one-slot -wo-margin">
              <label for="">{{$t('registro.cp')}}</label>
              <input type="text" name="cp" v-model="tutorObject.cp" v-validate="'numeric|min:5'" autocomplete="nope" @change="saveBtnTutor = true">
            </div>
            <div class="contenedor-input  row-start">
              <span class="btn -solid-primary mb-0" @click="saveTutor" v-if="saveBtnTutor">{{$t('guardar')}}</span>
            </div>
          </form>
          <template v-else>
            <div class="container-loading row-center w-100" v-if="loadingTutor">
              <loading></loading>
            </div>
            <div v-if="loadingTutor  == false " class="container" style="margin-top:-10px;">
              <div class="contenedor-datos row-start" >
                <h3 class="dato-cv">
                  <strong>{{ $t('formulario_incorporacion.tutor_nombre_apellidos') }}: </strong>
                  <template v-if="tutorObjectData.nombre">
                    <template v-if="tutorObjectData.tratamiento">{{tutorObjectData.tratamiento}}</template>
                    {{tutorObjectData.nombre}} 
                    <template v-if="tutorObjectData.apellidos">{{tutorObjectData.apellidos}}</template>
                  </template>
                </h3>
                <h3 class="dato-cv"  v-if="tutorObjectData.email">
                    <strong>{{$t('registro.email')}}: </strong>
                  {{tutorObjectData.email}}
                </h3>
                <h3 class="dato-cv" v-if="tutorObjectData.telefono1">
                  <strong>{{ $t('formulario_incorporacion.tutor_telefono') }}: </strong>
                  {{tutorObjectData.telefono1}}
                </h3>
                 <h3 class="dato-cv"  v-if="tutorObjectData.telefono2">
                  <strong>{{ $t('formulario_incorporacion.tutor_telefono') }} 2: </strong>
                   {{tutorObjectData.telefono2}}
                </h3>
                <h3 class="dato-cv"  v-if="tutorObjectData.nif">
                  <strong>NIF: </strong>
                  {{tutorObjectData.nif}}
                </h3>
                <h3 class="dato-cv" v-if="tutorObjectData.puesto">
                  <strong>{{ $t('formulario_incorporacion.tutor_cargo') }}: </strong>
                  {{tutorObjectData.puesto}}
                </h3>
                <h3 class="dato-cv" v-if="tutorObjectData.departamento">
                  <strong>{{ $t('formulario_incorporacion.departamento') }}: </strong>
                   {{tutorObjectData.departamento}}
                </h3>
                <h3 class="dato-cv" v-if="tutorObjectData.direccion">
                  <strong>Dirección: </strong>
                    {{tutorObjectData.direccion}}
                   <template v-if="!!tutorObjectData.idLocalidad">
                    , {{ provinciasComplet[tutorObjectData.provincia].localidades[tutorObjectData.idLocalidad] }}
                    </template>
                    <template v-else>
                      <template v-if="!!tutorObjectData.localidad">
                    , {{ tutorObjectData.localidad }}
                    </template>
                    </template>
                  <template  v-if="!!provinciasComplet[tutorObjectData.provincia]">
                    , {{ provinciasComplet[tutorObjectData.provincia].nameProvincia }}
                    </template>
                    <template v-else>
                        <template v-if="!!tutorObjectData.provinciaOtros">
                        , {{ tutorObjectData.provinciaOtros }}
                        </template>
                    </template>
                    <template v-if="!!tutorObjectData.idPais">
                    , {{ $t('paisesList')[tutorObjectData.idPais] }}
                    </template>
                     <template v-if="!!tutorObject.cp">
                    , {{ tutorObject.cp }}
                  </template>
                </h3>
              </div>
            </div>
          </template>
        </div>

      </template>
</section>

</template>

<script lang="js">
  import Vue from 'vue'
  import { mapActions, mapGetters } from 'vuex';
  import VeeValidate from 'vee-validate';
  import loading from '@/components/parts/loading';
  import axios from 'axios'
  Vue.use(VeeValidate);
  export default  {
    name: 'firmantes-anexos-select',
    props: ['errorFirst', 'idFirmanteAnexo' ,'listadoFirmanteConvenio', 'idEmpresa'],
    components: {
        'loading': loading
    },
    mounted() {
      if (!!!window.location.search) {
        this.requestFirmantesConvenio()
      }
      if (this.nocompletTutor) {
        this.tutorObject = {
            email : ''
          }
      } else {
        this.tutorObject = {
          tratamiento: '',
        }
      }
      if (this.idFirmanteAnexo && this.tutoresSelect && this.tutoresSelect[this.idFirmanteAnexo]) {
        this.tutorObject = this.tutoresSelect[this.idFirmanteAnexo]
      } 
    },
    data() {
      return {
        emailFirmante:null,
        openEditData:false,
        okContacto:false,
        createContacto:false,
        loadingCheched: false,
        nocompletTutor: this.errorFirst,
        tutorObject: {
            tratamiento:'',
        },
        tutorObjectData: {
          nameComplet:''
        },
        idContactoTutorEmpresa: '',
        loadingTutor: false,
        saveBtnTutor: true,
        nuevoTutorId : null
      }
    },
    computed: {
        ...mapGetters({
            tutores: 'getFirmantesConvenios',
            paises: 'getPaises',
            provincias: 'getProvincias',
            dominios: 'getDominios',
            alumno: 'isAlumno',
            empresaData :'getEmpresaAlumno',
            provinciasComplet: 'getProvinciasComplet',
            alumno: 'isAlumno'

        }),
      tutoresSelect: {
        get() {
          if (window.location.search) {
            let tutores = {}
            Object.entries(this.listadoFirmanteConvenio).forEach(element => {
              let obj = {
                id: element[0],
                nameComplet: element[1],
                nombre: element[1]
              }
              tutores[element[0]] = Object.assign({}, obj)
            })
            return tutores
          } else {
            if (this.alumno) {
              let tutoresEmpresa = {}
              Object.entries(this.empresaData.contactosTipoFirmanteConvenio).forEach(element => {
                let obj = {
                  id: element[0],
                  nameComplet: element[1],
                  nombre: element[1]
                }
                tutoresEmpresa[element[0]] = Object.assign({}, obj)
              })
              return tutoresEmpresa
            } else {
              return this.tutores;
            }
          }

        }
      },
      tutoresSelectOrdenados() {
        return Object.values(this.tutoresSelect || {})
          .sort((a, b) => String(a.nameComplet).localeCompare(String(b.nameComplet)))
      }
    },
    methods: {
        ...mapActions(['requestFirmantesConvenio','requestSaveFirmanteConvenio',  'requestDatosEmpresa', 'requestSaveFirmanteConvenioAlumno','comprobarExisteContacto']),
        localidadesfilter(idProvincia) {
            let localidades;
            if (!!this.dominios.localidades) {
                localidades = this.dominios.localidades.filter(l => l.idProvincia == idProvincia);
                localidades = localidades.sort(function (p1, p2) {
                    return (p1.descripcion < p2.descripcion) ? -1 : 1;
                });
            }
            return localidades
        },
      changeTutor() {
        let id = this.nuevoTutorId ? this.nuevoTutorId : this.tutorObject.id
        if (this.alumno) {
          axios.get(`/api/alumno/dameDatosContactoPorId/` + id).then(response => {
            this.tutorObjectData = Object.assign({}, this.tutorObject, response.data.datos)
            this.$emit('setFirmanteConvenio', this.tutorObjectData);
            // console.log(this.tutorObjectData)
          }).catch(function (error) { });
        } else {
          if (window.location.search) { 
            axios.post(`/api/empresa/dameDatosContactoPorId`, {
              "parametrosControl": window.location.search.replace('?p=', ''),
              "idContacto": this.tutorObject.id
            }).then(response => {
                this.tutorObjectData = Object.assign(this.tutorObject, response.data.datos)
              this.$emit('setFirmanteConvenio', this.tutorObject);
             }).catch({})
          } else {
            axios.get(`/api/empresa/dameDatosContactoPorId/` + id).then(response => {
            this.tutorObjectData = Object.assign({}, this.tutorObject, response.data.datos)
            this.$emit('setFirmanteConvenio', this.tutorObjectData);
            // console.log(this.tutorObjectData)
            }).catch(function (error) { });
          }
          
        }
            this.idContactoTutorEmpresa = parseInt(this.tutorObject.id)
            this.saveBtnTutor = false
            this.nocompletTutor = false
            
             
            
        },
       newTutor: function () {
            this.nocompletTutor = false
            this.tutorObject = {}
            if (this.alumno) {
              this.tutorObject.idEmpresa = this.empresaData.idEmpresa
            }else {
              this.tutorObject.idEmpresa = this.idEmpresa
            }
            this.tutorObject.tratamiento = ""
            this.tutorObject.idPais = ""
            this.saveBtnTutor = true
        },
        saveTutor: function () {
          this.$validator.validateAll().then(result => {
                if (result) {
                    this.loadingTutor = true;
                  if (this.alumno) {
                    this.requestSaveFirmanteConvenioAlumno(this.tutorObject).then(result => {
                      if (result.idNuevaAlta != null) {
                        this.nuevoTutorId = result.idNuevaAlta
                        let obj = {
                          id: result.idNuevaAlta,
                          nameComplet: this.tutorObject.nombre + ' '+ this.tutorObject.apellidos,
                          nombre: this.tutorObject.nombre
                        }
                        this.tutoresSelect[result.idNuevaAlta] = Object.assign({}, obj)
                        this.changeTutor()
                        this.tutorObject = this.tutoresSelect[this.nuevoTutorId]
                        this.openEditData = false
                        this.nocompletTutor = true
                        this.createContacto = true
                      }
                      if (result != null) {
                        this.loadingTutor = false;
                        this.saveBtnTutor = false;
                      }
                    });
                  } else {
                    this.requestSaveFirmanteConvenio(this.tutorObject).then(result => {
                      if (result.idNuevaAlta != null) {
                        this.nuevoTutorId = result.idNuevaAlta
                        this.tutorObject.id = result.idNuevaAlta
                        let obj = {
                          id: result.idNuevaAlta,
                          nameComplet: this.tutorObject.nombre + ' '+ this.tutorObject.apellidos,
                          nombre: this.tutorObject.nombre
                        }
                        this.tutoresSelect[result.idNuevaAlta] = Object.assign({}, obj)
                        this.changeTutor()
                        this.tutorObject = this.tutoresSelect[this.nuevoTutorId]
                      }
                      if (result != null) {
                        this.loadingTutor = false;
                        this.saveBtnTutor = false;
                      }
                    });
                  }
                }
            })
        },
        validarTutor: function () {
          this.$validator.validate('emailFirmante').then((result) => {
             this.loadingCheched = true
            if (result) {
              this.comprobarExisteContacto([this.emailFirmante, this.empresaData.idEmpresa]).then(r => { 
              if (r.status ==  0) {
                this.tutorObject = r.datos
                this.$emit('setFirmanteConvenio', this.tutorObject);
                this.openEditData = false
                this.nocompletTutor = true
                this.okContacto = true
              } else {
                this.openEditData = true
                this.nocompletTutor = false
                this.tutorObject = {}
                this.tutorObject.idEmpresa = this.empresaData.idEmpresa
                this.tutorObject.email = this.emailFirmante
                this.tutorObject.tratamiento = ""
                }
                
              this.loadingCheched = false
            })
            }
              else {
              this.loadingCheched = false
            }
          })
        }
  },
  watch: {
    'tutoresSelect': function () {
      if (this.nuevoTutorId) {
            this.tutorObject = this.tutoresSelect[this.nuevoTutorId]
            this.idContactoTutorEmpresa = parseInt(this.tutorObject.id)
        
      } else {
          this.tutorObject = this.tutoresSelect[this.idFirmanteAnexo]
      }
    //  console.log('watch =>' + this.tutoresSelect[this.idFirmanteAnexo])
    },
    'emailFirmante': function () {
      this.tutorObject.nombre = '',
      this.okContacto = false,
      this.createContacto = false
    }
  }                
  }
</script>

<style scoped lang="scss">
.contenedor-validador {
  width: 100%;
  margin-bottom: 10px;

  .btn {
    margin-left: 40px;
    margin-bottom: 20px
  }
}
</style>




// WEBPACK FOOTER //
// src/components/parts/form/firmantes-convenio-select.vue